/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/MindHarborOrderHistory/UserOrderHistory.Constants',[
    'jquery',
    'lodash',
    'global/all',
    'plugins/jquery.proxyRequest',
    'plugins/jquery.rocparams'
], function ($, _, Roc) {
    'use strict';

    var UserOrderHistorySelectors = {
        orderHistoryWrapper: '#mindHarborOrderHistoryContainer',
        ordersWrapper: '[data-roc-wrapper="ordersWrapper"]',
        orderDetailsBtn: '[data-roc-action="viewDetails"]',
        itemHistoryBtn: '[data-roc-action="viewItemHistory"]',
        itemHistoryDetailBtn: '[data-roc-action="viewItemHistoryDetail"]',
        itemQuickView: '[data-roc-action="openQuickView"]',
        searchBar: {
            searchPanel: '[data-roc-action="ordersSearchPanel"]',
            searchBtn: '[data-roc-action="ordersSearchBtn"]',
            status: '[data-roc-field="orderStatusSelect"]',
            dateRange: '[data-roc-field="orderDateRange"]',
            dateRangeLabel: '#daterangecontainer span',
            sortOrder: '[data-roc-field="sortOrderSelect"]',
            customerId: '[data-roc-field="customerIdSelect"]',
            shipTo: '[data-roc-field="shiptoSelect"]',
            filterNumbers: '[data-roc-field="orderNoMultipleFiltersInput"]'
        },
        wrappers: {
            dateRange: '[data-roc-wrapper="dateRange"]',
            accountName: '[data-roc-wrapper="accountName"]'
        },
        paging: {
            nextPage: '[data-roc-action="nextOrderPage"]',
            prevPage: '[data-roc-action="prevOrderPage"]',
            pageTextBox: '[data-roc-field="orderPageTextBox"]'
        },
        dynamic: {
            orderDetails: function (orderId) {
                return '#order-' + orderId + '-details';
            }
        }
    };


    Roc.Logger.debug('UserOrderHistory.Selectors.js Loaded:', UserOrderHistorySelectors);

    return UserOrderHistorySelectors;
});
